import { render, staticRenderFns } from "./PaginationTemplate.vue?vue&type=template&id=d360c5da"
import script from "./PaginationTemplate.vue?vue&type=script&lang=js"
export * from "./PaginationTemplate.vue?vue&type=script&lang=js"
import style0 from "./PaginationTemplate.vue?vue&type=style&index=0&id=d360c5da&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports